import { render } from "./fence.vue?vue&type=template&id=cf2cc22e&scoped=true"
import script from "./fence.vue?vue&type=script&lang=js"
export * from "./fence.vue?vue&type=script&lang=js"

import "./fence.vue?vue&type=style&index=0&id=cf2cc22e&scoped=true&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf2cc22e"]])

export default __exports__